import { environment } from '../environments/environment';
import { DATE_PROFILE_URL } from '../../../shared-util/src/lib/profile-date.service';
import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import {
  APEX_THEME_STORAGE_KEY,
  APEX_THEME_STORAGE_KEYS,
  ApexPrimeNgPreset,
  ApexThemeService,
} from 'shared-ui';

import { routes } from './app.routes';
import { authExpiredInterceptor } from './core/interceptors/auth-expired.interceptor';
import { credentialsInterceptor } from './core/interceptors/credentials.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: DATE_PROFILE_URL, useValue: `${environment.apiGatewayUrl}/api/v1/profile` },
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    // The same key index.html reads before the app starts, so the first paint and the app agree.
    { provide: APEX_THEME_STORAGE_KEY, useValue: APEX_THEME_STORAGE_KEYS.maintenance },
    provideAppInitializer(() => {
      inject(ApexThemeService);
    }),
    providePrimeNG({
      theme: {
        preset: ApexPrimeNgPreset,
        options: {
          darkModeSelector: "html[data-theme='dark']",
        },
      },
    }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptors([credentialsInterceptor, authExpiredInterceptor])),
  ],
};
